import LecturePrototypeModuleListResourcePagingResultModel from '../../generated/types/model/resource/LecturePrototypeModuleListResourcePagingResultModel';

export default class LecturePrototypeModuleListResourcePagingResultViewModel extends LecturePrototypeModuleListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
